export function audioMessageKeyForError(error = {}) {
  if (error.code === "daily_audio_limit" || error.code === "daily_audio_limit_reached") {
    return "audio.error.dailyAudio";
  }
  if (error.code === "ai_audio_daily_cap_exhausted") return "audio.error.dailyAiAudio";
  if (error.code === "ai_budget_exhausted") return "audio.error.systemDemand";
  if (error.code === "PAID_API_USER_DAILY_BUDGET_EXCEEDED") {
    return "audio.error.premiumDailyBudget";
  }
  if (error.code === "PAID_API_SYSTEM_DAILY_BUDGET_EXCEEDED") {
    return "audio.error.systemDailyBudget";
  }
  if (error.code === "premium_required") return "audio.error.premiumRequired";
  if (error.code === "audio_voice_unsupported_for_language") {
    return "audio.error.narratorLanguage";
  }
  if (error.code === "device_speech_voice_unavailable") {
    return "audio.error.deviceVoiceUnavailable";
  }
  if (error.code === "audio_no_content") return "audio.error.noContent";
  if (error.status === 0 || error.status >= 500) return "audio.error.serviceUnavailable";
  return "audio.error.unavailable";
}

export function audioQuotaKindForError(error = {}) {
  if (error.code === "daily_audio_limit" || error.code === "daily_audio_limit_reached") {
    return "daily_audio";
  }
  if (error.code === "ai_audio_daily_cap_exhausted") return "daily_ai_audio";
  if (error.code === "PAID_API_USER_DAILY_BUDGET_EXCEEDED") return "paid_user_budget";
  if (
    error.code === "PAID_API_SYSTEM_DAILY_BUDGET_EXCEEDED" ||
    error.code === "ai_budget_exhausted"
  ) {
    return "system_budget";
  }
  if (error.code === "premium_required") return "premium_required";
  if (error.status >= 500 || error.status === 0) return "service";
  return undefined;
}

export function audioSubscribeCtaAuthorityForError(error = {}) {
  const body = error?.body;
  if (
    error?.code !== "PAID_API_USER_DAILY_BUDGET_EXCEEDED" ||
    !body ||
    typeof body !== "object" ||
    Array.isArray(body) ||
    body.scope !== "user" ||
    !["free", "trial", "premium"].includes(body.tier) ||
    typeof body.showSubscribeCta !== "boolean"
  ) {
    return undefined;
  }
  return body.showSubscribeCta;
}

export function shouldShowAudioUpgradeCta(kind, showSubscribeCta) {
  if (kind === "paid_user_budget") return showSubscribeCta === true;
  return (
    kind === "daily_audio" ||
    kind === "daily_ai_audio" ||
    kind === "premium_required"
  );
}
